import Vue from "vue";
// import Axios from "axios";
const axios = require("axios");
Vue.config.productionTip = false;

axios.defaults.headers.common["X-CSRFToken"] = mparc.csrf;


Vue.filter("prop_to_percent", function (value) {
    if (!value) {
        return "";
    }
    return (value * 100).toFixed(1) + "%";
})